<template>
  <div class="pay">
    <header-com :scheme="scheme" />
    <select-address
      v-show="(!scheme && !isActive) "
      class="address"
      @changeType="changeType"
      :sendFrom="sendFrom"
      @changeAdr="changeAdr"
      @changeDate="changeDate"
      @action="action"
      ref="setAdr"
    ></select-address>
    <div class="block" v-show="(!scheme && !isActive)"></div>
    <div class="goodsList" :class="{mt104:(scheme || isActive) }">
      <div>
        <span class="title">订单信息</span>
      </div>
      <div class="img_cont">
        <div>
          <img
            v-for="(item,index) in detail.goodsList"
            :key="index"
            :src="setImg(item)"
            v-if="index <=3"
            class="item_icon"
          />
        </div>
        <div class="moreGoods" @click="moreGoodsShow">
          <span>共{{detail.goodsList.length}}件</span>
          <img src="/images/base/threemore.png" class="moreTips" />
        </div>
      </div>
    </div>
    <div class="block"></div>
    <div class="container" v-if="!isActive">
      <div class="coupon f30" v-if="!scheme">
        <div class="fw500 f32">怎么付款</div>
        <div class="right f24 grey6 payTypeOther"></div>
      </div>

      <div class="coupon f30" v-if="!scheme && !isActive">
        <div class="type">
          <div
            class="express"
            :class="{active_other:payTypeOther==2}"
            @click="payTypeOtherChange('2')"
          >
            <p>诊断后付款</p>
            <p class="dero">先寄包，诊断后再付款</p>
          </div>
          <div
            class="courier"
            :class="{active_other:payTypeOther==1}"
            @click="payTypeOtherChange('1')"
          >
            <p>立即支付</p>
            <p class="dero">先预付，如未使用自主退款</p>
          </div>
        </div>
      </div>

      <div
        class="coupon f30"
        @click="selectCoupon"
        v-show="(payTypeOther == '1' || scheme) && !isActive"
      >
        <span class="fw500 f32">可用优惠</span>
        <span class="right f24 grey6">{{couponText}}</span>
      </div>
    </div>
    <div class="amount f30 bgg" v-show="(payTypeOther == '1'  || scheme) && !isActive">
      <div>
        <p class="fw500">
          余额支付
          <span class="fwnolmol">（当前余额：{{detail.surplusAmount}}元）</span>
        </p>
        <p class="f20 grey9 mt20">为了更好的服务你，我们会优先选择余额支付</p>
      </div>
      <div>
        <my-switch
          :checkSwitch="useBalance"
          @change-switch="changeSwitch"
          v-show="detail.surplusAmount && detail.surplusAmount != 0"
        />
      </div>
    </div>
    <!-- <div class="block"></div> -->

    <div v-if="promotionRechargeRule&&promotionRechargeRule.type==10" class="cardBox">
			<div class="cardBoxSon1">
				<div class="vipCard vipCard_1">
					<div>
						<div class="title">赠送{{ promotionRechargeRule.remark }}</div>
						<div class="price">¥{{ promotionRechargeRule.amount }}</div>
						<template v-if="promotionRechargeRule.amount === 2000">
							<div class="word">充值金额可与赠送抵扣券同享</div>
						</template>
						<template v-else>
							<div class="word">充值金额可与优惠券同享</div>
						</template>
					</div>
					<div class="recharge" @click="showPopup(promotionRechargeRule)">立即充值</div>
				</div>
			</div>
      
		</div>

    <div v-if="promotionRechargeRule&&promotionRechargeRule.type==20" class="cardBox">
			<div class="cardBoxSon2" @click="chooseMemberCardFn">
				<div class="discountCard discountCard_1">
					<div>
						<div class="title">{{ promotionRechargeRule.name }}</div>
						<div class="word">本次可省<span class="savePrice">{{promotionRechargeRule.discountAmount}}元</span></div>
						<div class="day">{{ promotionRechargeRule.discountCardDayTime }}天{{ promotionRechargeRule.remark }}</div>
					</div>
          <div class="priceCard">¥{{ promotionRechargeRule.amount }}</div>
					<div class="radio">
            <div v-if="!chooseMemberCard" class="noRadio"></div>
            <div v-if="chooseMemberCard" class="yesRadio"></div>
          </div>
				</div>
			</div>
		</div>

    <div class="container" v-show='payTypeOther == "1"  || scheme' style="padding-top:0">
      <div class="pay-info">
        <li>
          <span class="f26">订单金额</span>
          <span class="f30 bold">¥{{detail.amount}}</span>
        </li>
        <li v-for="(item,index) in detail.settlementDiscount">
          <span class="f26">
            {{item.name}}
            <span
              class="prefere"
              v-if="item.discountList && item.discountList.length !=0"
              v-for="(data,dataIndex) in item.discountList"
            >{{data.name}}</span>
          </span>
          <span class="f30 bold reds">{{item.value}}</span>
        </li>

        <li v-if="chooseMemberCard">
          <span class="f26">
            {{promotionRechargeRule.name}}
          </span>
          <span class="f30 bold reds">{{promotionRechargeRule.amount}}</span>
        </li>

      </div>
      <div class="block" v-if='detail.realAmount != 0 && payTypeOther == "1"'></div>
      <div class="pay-style" v-if='detail.realAmount != 0 && payTypeOther == "1"'>
        <li @click="payType=true">
          <img class="icon" src="/images/order/wechat.png" alt />
          <div class="name" :class="{borderNone:isWeiXin}">微信支付</div>
          <div class="radio" v-if="!isWeiXin">
            <radio :checked="payType" />
          </div>
        </li>
        <li @click="payType=false" v-if="!isWeiXin">
          <img class="icon alipay" src="/images/order/alipay.png" alt />
          <div class="name">支付宝支付</div>
          <div class="radio">
            <radio :checked="!payType" />
          </div>
        </li>
      </div>
      <div class="block"></div>

      <div v-if="detail.promotionGifts">
        <div class="pay-info" v-for="(item,index) in detail.promotionGifts" :key="index">
          <div class="gift_title">{{item.promotionName}}</div>
          <ul v-for="(data,dataIndex) in item.gifts">
            <li class="gift_content" @click="radioGift(item.promotionId,data.id)">
              <div class="gift_list">
                <radio :checked="gitfId == data.id" />
                <img :src="formatImgUrl(data.picTemplate,100,100,true)" v-show="data.picTemplate" />
                <span>{{data.name}}</span>
              </div>
              <div class="gift_num">{{data.priceText}}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="block" v-show="detail.promotionGifts"></div>
    </div>

    <div class="copyright_content">
      <div class="copyright" @click="agreement = !agreement">
        <div class="copyright_radio" style="display: inline-block;width: 20px;height: 20px;position: absolute;">
          <radio :checked="agreement" />
        </div>&nbsp;&nbsp;<span style="margin-left:20px"></span>确认支付等同于同意
        <span @click='$router.push({name:"agreement",query:{type:"two"}})'>《包拯售前协议》</span>及
        <span @click='$router.push({name:"agreement",query:{type:"one"}})'>《包拯售后服务标准》</span>
      </div>
    </div>

    <div class="copyright_content" v-if="mustAgree">
      <div class="copyright" @click="serviceClick">
        <div class="copyright_radio" style="display: inline-block;width: 20px;height: 20px;position: absolute;">
          <radio :checked="argeeService" />
        </div>&nbsp;&nbsp;<span style="margin-left:20px"></span>确认支付等同于同意
        <span>《改样服务协议》</span>
      </div>
    </div>

    <div class="postage" v-if="false">温馨提示：所在区域为非包邮区，邮费自付</div>
    <div class="g-fixed-bottom toolbar">
      <button
        class="primary"
        @click="confirm"
        :disabled="(!agreement || paying) || (mustAgree&&!argeeService)"
        v-show="payTypeOther == '1'  || scheme"
      >{{payingText}}</button>
      <button
        class="primary"
        @click="confirm"
        :disabled="(!agreement || paying) || (mustAgree&&!argeeService)"
        v-show="payTypeOther != '1' &&  !scheme"
      >确定支付</button>
      <div v-if="payTypeOther == '1' || scheme">
        实付金额：¥
        <span class="money">{{detail.realAmount}}</span>
      </div>
    </div>


    <!-- 改样服务协议 -->
    <van-popup v-model='servicePopup' position="bottom" :style="{ height: '80%' }" :closeable='true'>
      <div class="serviceBox" ref="serviceBox" @scroll.passive="serviceScroll($event)">
        <div :class="scrollSlide?'serviceContent serviceContent2':'serviceContent'" ref="serviceContent">
          <h4 style="font-weight:600">《改样服务协议》</h4>
          <br>
          <h6 class="serviceH6">
            &#x3000;&#x3000;尊敬的用户，欢迎您接受由包拯工作室为您提供的皮包改样服务。您在接受我们的服务之前，请务必仔细阅读本用户协议。<br>
            &#x3000;&#x3000;点击“同意”按钮，即表示您已阅读并同意本协议下的全部条款，包括包拯工作室对服务条款做的任何更改。您一旦接受包拯工作室的改样服务，即视为您已充分了解并完全同意本服务条款的所有内容。
          </h6>
          <br>
          <h6 class="serviceH6" style="font-weight:600">&#x3000;&#x3000;第一条 服务内容</h6>
          <h6 class="serviceH6">
            &#x3000;&#x3000;改样服务是指有私有物品改样需求的个人消费者，基于自身使用的目的，委托包拯工作室将其拥有所有权的私有物品改造成指定样式的个性化定制服务。您需要了解并接受以下服务内容：<br>
            &#x3000;&#x3000;1.原则上，包拯工作室只为个人消费者提供改样服务，不为任何组织提供本服务。<br>
            &#x3000;&#x3000;2.改样后的物品须用于私人日常使用，而不能用于商业用途盈利。<br>
            &#x3000;&#x3000;3.改样服务内容仅限于用户提供的私有物品的手工改样以及破损部位的修复（如有必要），不包括任何商品的制造或销售，也不包括鉴定、验真等附属内容。<br>
            &#x3000;&#x3000;若您不是个人消费者，或您的行为代表了任何组织的意志，或您企图将改样后的物品用于商业或非私人用途，请勿接受本协议。
          </h6>
          <br>
          <h6 class="serviceH6" style="font-weight:600">&#x3000;&#x3000;第二条 权利义务</h6>
          <h6 class="serviceH6">
            &#x3000;&#x3000;1.用户对需改样物品应拥有合法权利，委托改样行为不会侵犯任何第三人的合法权益。<br>
            &#x3000;&#x3000;2.用户委托的内容不应侵犯任何第三人的合法权益。若涉嫌侵权，包拯工作室有权拒绝接受该委托内容。<br>
            &#x3000;&#x3000;3.用户保证所提供的物品信息真实、准确、完整，如有变更应及时更新。<br>
            &#x3000;&#x3000;4.用户应对其指定的改样款式负责。因改样款式引发的一切纠纷均由用户自行负责，包拯工作室不承担任何法律或连带责任。<br>
            &#x3000;&#x3000;5.用户对改样后的物品享有全部权益并对其个人的使用行为承担全部法律责任。因用户违反相关法律法规引发的一切纠纷均由用户自行负责，包拯工作室不承担任何法律或连带责任。<br>
            &#x3000;&#x3000;6.包拯工作室可以根据服务内容向用户收取相应的服务费。<br>
            &#x3000;&#x3000;7.包拯工作室保证服务质量，严格按照用户要求进行改样服务，在改样、修复过程中使用的原料、工艺等符合相关法律法规的规定。
          </h6>
          <br>
          <h6 class="serviceH6" style="font-weight:600">&#x3000;&#x3000;第三条 保护知识产权的特别约定</h6>
          <h6 class="serviceH6">
            &#x3000;&#x3000;为保护第三方的商标、专利权等知识产权，禁止用户将改样后的物品以正品的名义或以可能引起与正品混淆误认的方式向第三人宣传销售。
          </h6>

          <br>
          <h6 class="serviceH6" style="font-weight:600">&#x3000;&#x3000;第四条 不可抗力及免责</h6>
          <h6 class="serviceH6">
            &#x3000;&#x3000;您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务受到影响。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于罢工，暴乱，火灾，洪水，风暴，爆炸，战争而造成的不能服务或延迟服务承担责任等。出现上述情况时，我们将努力在第一时间与相关单位配合，争取及时进行处理，但是由此给您造成的损失，我们在法律允许的范围内免责。
          </h6>
          
          <br>
          <h6 class="serviceH6" style="font-weight:600">&#x3000;&#x3000;第五条 违约责任</h6>
          <h6 class="serviceH6">
            &#x3000;&#x3000;若用户违反上述约定给包拯工作室或者第三人的合法权益造成损害，应承担相应的赔偿责任。<br>
            &#x3000;&#x3000;若用户因违反上述约定侵犯第三人的知识产权，导致包拯工作室向第三人赔偿或受到执法机构处罚，用户应承担连带责任并赔偿包拯工作室因此遭受的相关损失。
          </h6>

          <br>
          <h6 class="serviceH6" style="font-weight:600">&#x3000;&#x3000;第六条 服务的变更、中断或终止</h6>
          <h6 class="serviceH6">
            &#x3000;&#x3000;如因政策、法律或包拯业务的调整而需要暂停或变更改样服务内容、服务价格、用户协议等条款，包拯工作室将尽可能通过官方渠道或其他途径向用户公告或通知。<br>
            &#x3000;&#x3000;如发现下列任何一种情况，对此产生的任何争议或纠纷，包拯工作室不承担任何责任，且有权单方面中断或终止服务：<br>
            &#x3000;&#x3000;1.用户并非个人消费者的；<br>
            &#x3000;&#x3000;2.用户拟将改样后的物品用于商业用途盈利的；<br>
            &#x3000;&#x3000;3.用户违反相关约定侵犯第三人知识产权或相关权益的。<br>
            &#x3000;&#x3000;4.用户商品来源存在违法行为，如盗窃、走私、非法买卖、侵犯他人合法权益等；<br>
            &#x3000;&#x3000;5.用户商品来源存在不明确或虚假的情况，可能存在使用上的风险或法律风险；<br>
            &#x3000;&#x3000;6.用户商品来源不合法或存在问题导致在使用或销售过程中被相关机构处罚或追究法律责任。
          </h6>

          <br>
          <h6 class="serviceH6" style="font-weight:600">&#x3000;&#x3000;第七条 服务条款的完善和修改</h6>
          <h6 class="serviceH6">
            &#x3000;&#x3000;包拯工作室有权根据自身业务的发展和中华人民共和国有关政策、法律法规的变化，不时地完善和修改包拯工作室的服务条款。用户在接受包拯工作室改样服务时应该仔细阅读和重新确认。当发生有关争议时，将以最新的服务条款为准。
          </h6>

        </div>
      </div>
      <div v-if="!canBtnclick" class="serviceBtn serviceBtnGray">请上滑看完本条款再同意</div>
      <div v-if="canBtnclick" @click="argeeServiceFn" class="serviceBtn">同意本条款，下次不再提示</div>
    </van-popup>
    <!-- 改样服务协议 -->


    <!-- //选择优惠券弹窗 -->
    <van-popup position="bottom" v-model="isShow">
      <div class="containers f28">
        <div class="title">选择优惠券</div>
        <ul>
          <li
            v-for="(item, index) in couponList"
            :key="index"
            :style="{'backgroundImage':'url(/images/my/' + getItem(item).backgroundImg+'.png)'}"
            @click="choseCouponList(item)"
          >
            <!-- <radio :checked="true" v-if="item.couponId == coupon.id" class="couponRadio"></radio> -->
            <div class="inner" :class="{paddigleft:item.couponId == coupon.id}">
              <h3 v-html="getItem(item).title" class="conpentitle"></h3>
              <h4 class="f24 describe">{{item.description}}</h4>
              <!-- <h5 class="f20 grey6">满180元可使用，适用包包数量1个</h5> -->
              <time
                class="f20 grey9 time"
              >{{item.startTime.split(' ')[0]}} 至 {{item.endTime.split(' ')[0]}}</time>
            </div>
          </li>
        </ul>
        <div>
          <div class="my_button" @click="nouseCoupon()">不使用优惠券</div>
        </div>
        <div class="close" @click="isShow=false"></div>
      </div>
    </van-popup>

    <!-- 商品详情-->
    <van-popup position="bottom" v-model="goodsShow">
      <div class="containers f28">
        <div class="title">
          订单信息
          <span class="goodsnum">共{{detail.goodsList.length}}件</span>
        </div>
        <div class="close" @click="goodsShow=false"></div>
        <div class="item_content">
          <goods-item
            v-for="(item,index) in detail.goodsList"
            :key="index"
            :model="item"
            :class="{paddingp:index=detail.goodsList.length -1}"
          ></goods-item>
        </div>
      </div>
    </van-popup>
    <van-popup  v-model="kanyidao" style="border-radius: 15px;">
      <div style="height:330px;width:271px;margin-left:calc(50% - 135px);">
          <img src="/images/order/kanyidao-doag.png"  style="height:329px;width:271px"/>
            <img src="/images/order/tidf-bottton.png" @click="goAskPage" style="height: 40px;width: 174px;position: relative;top: -70px;left: 50px;"/>
            <!-- <div  id="alldo" style="position:relative;height: 40px;width: 174px;z-index:999;top: -110px;left: 50px;">
            </div> -->
           <img src="/images/public/hideLog.png"  style=" height: 40px;width: 40px;position: relative;top: -70px;left: calc(50% - 20px);" @click="kanyidian=false"/> 
        </div>
    </van-popup>
    <!-- <div v-show="isWeiXin" v-bind:class="[scheme&&kanyidian&&kanhyidao&&(activityObj&&activityObj.status!=40||!activityObj) ? 'cool-dfs' : 'cool-dfsd']"    >
        
    </div> -->

    <!-- 余额充值 -->
    <van-popup
			v-model="isShowPopup"
			position="bottom"
			:overlay="true"
			:lock-scroll="true"
		>
			<section v-if="payItem" class="popupInners">
				<div class="close_cont" @click="isShowPopup = false">
					<div class="close"></div>
				</div>

				<div v-if="payItem.type==10" class="msgBox">
					<div class="price">
						<div class="price32">充值金额</div>
						<div class="price48">¥{{payItem.amount}}</div>
					</div>
					<div class="priceLine"></div>
					<div class="price">
						<div class="price32">赠送</div>
						<div class="price48">{{payItem.remark}}</div>
					</div>
				</div>

        <div v-if="payItem.type==20" class="msgBox">
					<div class="price">
						<div class="price32">金额</div>
						<div class="price48">¥{{payItem.amount}}</div>
					</div>
					<div class="priceLine"></div>
					<div class="price">
						<div class="price32">有效期</div>
						<div class="price48">{{payItem.discountCardDayTime}}天</div>
					</div>
				</div>

				<div class="wordBox">
					<div class="word">
						<span v-if="payItem.type==10">
              *充值{{payItem.amount}}元赠送{{payItem.remark}}<br />
							<template v-if="payItem.amount === 2000">
								*充值金额仅支持可与赠送3张抵扣券同享<br />
							</template>
							<template v-else>
								*可与优惠券同时使用<br />	
							</template>
            </span>
            <span v-if="payItem.type==20">
              *优惠特权卡在有效期内可无限次使用<br />
						  *不可与优惠券同时使用<br />
							*优惠特权卡使用后将不可退款<br />
            </span>
						*如有疑问，请致电400-052-0618<br />
						*活动解释权归包拯所有<br />
            *赠送金额为促销权益，非实际支付款项，随会员服务同步生效，退回时不支持单独折算退回<br />
					</div>
				</div>

				<div class="pay-style">
					<li @click="cardPayType = true">
						<img class="icon" src="/images/order/wechat.png" alt="" />
						<div class="name" :class="{ borderNone: isWeiXin }">
							微信支付
						</div>
						<div class="radio" v-if="!isWeiXin">
							<radio :checked="cardPayType" />
						</div>
					</li>
					<li @click="cardPayType = false" v-if="!isWeiXin">
						<img class="icon alipay" src="/images/order/alipay.png" alt="" />
						<div class="name">支付宝支付</div>
						<div class="radio"><radio :checked="!cardPayType" /></div>
					</li>
				</div>

				<div class="payBox">
					<template v-if="payItem.amount === 2000">
						<button class="primary myPay" @click="payConfirm" :disabled="cardPaying">
						{{ cardPayingText }}
					</button>
					</template>
					<template v-else>
						<button class="primary myPay" @click="primaryAction" :disabled="cardPaying">
						{{ cardPayingText }}
					</button>
					</template>
				</div>
			</section>
		</van-popup>
    <!-- 余额充值 -->

  </div>
</template>   

<script>
import myApi from "@/axios/my";
import loginApi from '@/axios/login'
import payObj from "@/assets/js/pay";
import { Toast, Dialog } from "vant";
import publicObj from "@/assets/js/public";
import zhugeObj from "@/assets/js/track";
import orderApi from "@/axios/order";
import getWXConfig from "@/assets/js/wx.config";
export default {
  name: "index",
  data() {
    return {
      firstClick: true,
      scrollSlide: false,
      argeeService: localStorage.getItem('argeeService') ? true : false,
      mustAgree: false,
      canBtnclick: false,
      servicePopup: false,
      promotionId: "",
      gitfId: "",
      kanyidian:true,
      goodsShow: false,
      useBalance: true,
      payType: true,
      agreement: true,
      kanhyidao:null,
      isShow: false,
      couponList: [],
      coupon: {},
      kanyidao:false,
      settlementId: "",
      detail: {
        useCoupon: {},
        goodsList: []
      },
      isWeiXin: true,
      scheme: false,
      customerInfo: {},
      couponCode: "",
      sizeNum: 0,
      paying: false,
      payingText: "支付",
      payTypeOther: "2",
      activityObj:null,
      sendFrom: {
        sendType: 40,
        customerAddressId: "",
        pickingDate: "",
        pickingTime: ""
      },
      payTypeOtherShow: false,
      isActive: false,
      isTeam: false,
      orderType: this.$route.query.orderType?this.$route.query.orderType:'',
      onlineIdStr:this.$route.query.onlineIdStr?this.$route.query.onlineIdStr:'',

      isShowPopup: false,
      payItem: null,
      cardPayType: true,
      cardPayingText: '立即充值',
      cardPaying: false,
      promotionRechargeRule: null,
      chooseMemberCard: false

    };
  },
  created() {
    zhugeObj.track({
      title: "用户支付",
      content: {
        页面曝光: "页面曝光"
      }
    });
    this.isWeiXin = publicObj.isWeiXin();
    // this.$route.query.type == 'scheme'?this.scheme = true:this.scheme = false;
    this.settlementId = this.$route.query.id;
    if (this.$route.query.type == "scheme") {
      this.scheme = true;
      this.payTypeOther = "1";
    } else {
      this.scheme = false;
    }

    if (this.$route.query.type && this.$route.query.type != "scheme") {
      if (this.$route.query.isTeam) {
        //曾经的拼团逻辑 暂时不用 预留这里
        this.isTeam = true;
      }
      this.isActive = true;
    } else {
      this.isActive = false;
    }

    if (this.isActive) {
      this.useBalance = false;
      this.payTypeOther = "1";
      this.sendFrom.sendType = 10;
      // if(this.isTeam){
      //   this.sendFrom.sendType = 40;
      // }
    }
   
  },
  computed: {
    couponText() {
      if (this.coupon) {
        if (this.couponList.length == 0) {
          return "暂无优惠券";
        } else {
          setTimeout(() => {}, 1000);
          if (this.coupon.couponName) {
            return this.coupon.couponName;
          } else {
            return "请选择优惠券";
          }
        }
      } else {
        return "暂无优惠券";
      }
    }
  },
  watch: {
    // detail(val,vd){
    //   this.takeOne();
    // }
  },
  mounted () {
    this.settlement();
      this.readActh()
  },
  methods: {
    chooseMemberCardFn() {
      this.chooseMemberCard = !this.chooseMemberCard
      if(this.chooseMemberCard) {
        this.payItem = this.promotionRechargeRule
        this.coupon = this.promotionRechargeRule.rechargeRuleGiftBoList[0];
        // this.isShow = true;
      } else {
        if(this.coupon.id) {
          this.promotionRechargeRule.rechargeRuleGiftBoList.map(item=>{
            if(item.giftId == this.coupon.id) {
              this.coupon = {}
            }
          })
        }
      }
      this.settlement();
    },
    showPopup(item) {
			this.isShowPopup = true;
      this.payItem = item
		},
    payConfirm() {
			this.$dialog.alert({
      	message: '充值金额仅支持可与赠送3张抵扣券同享'
    	}).then(() => {
				this.primaryAction()
			})
		},

    primaryAction() {
			let payParams = payObj.getPayParams(this.cardPayType);

			const openId = localStorage.getItem("openId");
			let params = {
				rechargeRuleId: this.promotionRechargeRule.id,
				openId: openId,
				backUrl: window.location.href,
			};

			if (publicObj.isWeiXin()) {
				params.paymentPlatform = "WeChat";
			} else {
				if (this.cardPayType) {
					params.paymentPlatform = "WeChat_h5";
				} else {
					params.paymentPlatform = "AliPay_h5";
				}
			}
			//支付参数
			this.cardPaying = true;
			this.cardPayingText = "充值中...";
			myApi
				.recharge(params)
				.then((res) => {
					zhugeObj.track({
						title: "支付页面-用户充值",
						content: {
							充值结果: "成功",
							充值金额: this.promotionRechargeRule.amount,
							赠品: ''
						},
					});
					if (params.paymentPlatform == "WeChat_h5") {
						window.location.href = res.paymentData.h5PayUrl;
						return;
					}
					if (params.paymentPlatform == "AliPay_h5") {
						window.location.href = res.paymentData.h5PayUrl;
						return;
					}

					payObj.confirmPay(payParams.payChannel, res.paymentData, 2,window.location.href);
				})
				.catch(() => {
					zhugeObj.track({
						title: "支付页面-用户充值",
						content: {
							充值结果: "失败",
							充值金额: this.promotionRechargeRule.amount,
							赠品: ''
						},
					});
					this.cardPaying = false;
					this.cardPayingText = "立即充值";
				});
		},

    argeeServiceFn() {
      localStorage.setItem('argeeService','1')
      this.argeeService = true
      this.servicePopup = false
    },

    serviceClick() {
      if(!this.argeeService) {
        this.servicePopup = true
        if(this.firstClick) {
          setTimeout(() => {
            this.scrollSlide = true
            this.firstClick = false
          }, 1000);
          setTimeout(() => {
            this.scrollSlide = false
          }, 1700);
        }
        
      } else {
        this.argeeService = false
        localStorage.removeItem('argeeService')
      }
    },

    serviceScroll(e) {
      var Target = e.target ? e.target : e.srcElement
      let maxScrollHeight = Target.scrollHeight - Target.offsetHeight
      let scrollTop = Target.scrollTop
      if(scrollTop>=maxScrollHeight-10) {
        this.canBtnclick = true
      }
    },

    goAskPage(){
       let goodsIds = []
        for(let obj of this.detail.goodsList){
          goodsIds.push(obj.id)
        }
        let pams = {
          bargainActivityId:this.kanhyidao.id,
          orderAmount:this.detail.amount,
          goodsIds:goodsIds.join(','),
          token:localStorage.getItem('token')
        }
        this.$router.push({name:'leadIndex',query:pams})
    },
    convertObj(data) {
      let _result = [];
      for (let key in data) {
        let value = data[key];
        if (value.constructor == Array) {
          value.forEach(function(_value) {
            _result.push(key + "=" + _value);
          });
        } else {
          _result.push(key + '=' + value);
        }
      }
      return _result.join('&');
    },
    
    takeOne(){
     

      let goodsIds = []
      for(let obj of this.detail.goodsList){
        goodsIds.push(obj.id)
      }
      let pams = {
        bargainActivityId:this.kanhyidao.id,
        orderAmount:this.detail.amount,
        goodsIds:goodsIds.join(','),
        token:localStorage.getItem('token')
      }
      getWXConfig()
      var dom = document.getElementById('alldo') //
      let url = this.convertObj(pams)
      dom.innerHTML = '<wx-open-launch-weapp path="Bargaining/pages/lead/index.html?'+url+'" id="launch-btn"   username="gh_f36f18f6beed"><template><div style="width:200px;height:50px;"></div></template></wx-open-launch-weapp>'
  
      var launchBtn = document.getElementById('launch-btn')
      if (!launchBtn) {
      return
      }
      launchBtn.addEventListener('launch', function (e) {
          zhugeObj.track({
              title: "自选下单页-客服按钮-点击",
          });
      })
      launchBtn.addEventListener('error', function (e) {
      console.log('fail', e.detail)
      })
    },
    radioGift(pid, id) {
      this.promotionId = pid;
      this.gitfId = id;
    },
    makeImg(index) {
      if (index == 1) {
        if (this.payTypeOther == 1) {
          return "_1";
        } else {
          return "";
        }
      } else {
        if (this.payTypeOther != 1) {
          return "_1";
        } else {
          return "";
        }
      }
    },
    payTypeOtherChange(str) {
      if (str == 2) {
        zhugeObj.track({
          title: "用户支付",
          content: {
            付款方式: "诊断后付款"
          }
        });
      } else {
        zhugeObj.track({
          title: "用户支付",
          content: {
            付款方式: "立即支付"
          }
        });
      }
      this.payTypeOtherShow = false;
      this.payTypeOther = str;
    },
    changeDate(data, time) {
      this.sendFrom.pickingDate = data;
      this.sendFrom.pickingTime = time;
    },
    changeAdr(element) {
      this.sendFrom.customerAddressId = element.id;
    },
    changeType(index) {
      if (index == 40) {
        zhugeObj.track({
          title: "用户支付",
          content: {
            快递方式: "顺丰上门"
          }
        });
      } else {
        zhugeObj.track({
          title: "用户支付",
          content: {
            快递方式: "自己快递"
          }
        });
      }
      this.sendFrom.sendType = index;
    },
    changepayTypeOther(index) {
      this.payTypeOther = index;
    },
    formatImgUrl(url, width, height, m_fill) {
      // console.log(url)
      if (url) {
        url = url.replace(
          "h_{height},w_{width}",
          "h_" + height + ",w_" + width + ""
        );
        // url = url.replace(',jpg', ",webp");
        url += ",q_80";
        if (m_fill) {
          // console.log(m_fill)
          url = url.replace("m_lfit", "m_fill");
        }
      }
      return url;
    },
    setImg(item) {
      if (item.goodsType == "goods") {
        return this.formatImgUrl(item.picTemplate, 300, 300, true);
      } else {
        if (item.categoryId == 3) {
          return "/images/newOrder/package1.png";
        } else if (item.categoryId == 4) {
          return "/images/newOrder/shoes1.png";
        } else if (item.categoryId == 5) {
          return "/images/newOrder/pajamas1.png";
        } else if (item.categoryId == 6) {
          return "/images/newOrder/accessories1.png";
        } else {
          return "/images/base/defult_pic.png";
        }
      }
    },
    moreGoodsShow() {
      this.goodsShow = true;
    },
    // {{coupon?coupon.couponName:'选择优惠券'}}
    nouseCoupon() {
      this.coupon = {};
      this.isShow = false;
      this.settlement();
    },

    settlement() {
      if(this.orderType === 'online') {
        this.onlineDetail();
        return
      }
      let couponCode = "";
      if (JSON.stringify(this.coupon) == "{}") {
        if (!this.sizeNum) {
          couponCode = null;
        } else {
          couponCode = "notUse";
        }
      } else {
        couponCode = this.coupon.couponCode;
      }
      let params = {
        orderCode: this.settlementId,
        useSurplus: this.useBalance ? 1 : 0,
        couponCode: couponCode,
        useExternalSurplus: 1
      };
      if(this.chooseMemberCard) {
        params.rechargeRuleId = this.payItem.id
      }
      this.sizeNum++;

      if (this.isActive) {
        params.couponCode = "notUse";
      }

      if (this.scheme) {
        myApi
          .schemesettlement(params)
          .then(res => {
            this.detail = res;
            if (this.detail.promotionGifts) {
              if (this.detail.promotionGifts[0]) {
                this.gitfId = this.detail.promotionGifts[0].gifts[0].id;
                this.promotionId = this.detail.promotionGifts[0].promotionId;
              }
            }
            if (!this.detail.surplusAmount && this.useBalance) {
              this.useBalance = false;
            }
            if (res.matchCustomerCoupon) {
              this.couponList = res.matchCustomerCoupon;
            } else {
              this.couponList = [];
            }
            if (res.useCoupon) {
              this.coupon = res.useCoupon;
            }
            if(res.goodsList.length>0) {
              this.serviceSureFn(res.goodsList)
            }
            // this.takeOne();
            if(res.promotionRechargeRule) {
              this.promotionRechargeRule = res.promotionRechargeRule
              zhugeObj.track({
              title: "方案中-去结算-展示会员卡",
              content: {
                会员卡类型: this.promotionRechargeRule.type==20?this.promotionRechargeRule.name:this.promotionRechargeRule.amount+'金额卡'
              }
            })
            }
          })
          .catch(res => {
            // alert(res.code);
            if (res.code == 10010) {
              orderApi.unpaid().then(res => {
                if (!res) {
                } else {
                  orderApi.settlementConcel(res.settlementCode).then(() => {
                    this.settlement();
                  });
                }
              });
            }
          });

        return;
      }

      myApi
        .settlement(params)
        .then(res => {
          // console.log(res)
          res.goodsList.forEach((item, index) => {
            item.unpaidCuringService.forEach((data, dataIndex) => {
              //存在拼团不能使用余额
              if (data.classify == 30) {
                this.isActive = true;
                this.isTeam = true;
                this.useBalance = false;
                this.payTypeOther = "1";
                // this.sendFrom.sendType = 40;
              }
            });
          });
          this.detail = res;
          if (this.detail.promotionGifts) {
            if (this.detail.promotionGifts[0]) {
              this.gitfId = this.detail.promotionGifts[0].gifts[0].id;
              this.promotionId = this.detail.promotionGifts[0].promotionId;
            }
          }
          if (!this.detail.surplusAmount && this.useBalance) {
            this.useBalance = false;
          }
          if (res.matchCustomerCoupon) {
            this.couponList = res.matchCustomerCoupon;
          } else {
            this.couponList = [];
          }
          if (res.useCoupon) {
            this.coupon = res.useCoupon;
          }
          if(res.goodsList.length>0) {
            this.serviceSureFn(res.goodsList)
          }
          // this.takeOne();
        })
        .catch(res => {
          // alert(res.code);
          if (res.code == 10010) {
            orderApi.unpaid().then(res => {
              if (!res) {
              } else {
                orderApi.settlementConcel(res.settlementCode).then(() => {
                  this.settlement();
                });
              }
            });
          }
        });
    },

    serviceSureFn(list) {
      let idReg = /^(520|935|1356|1357|1358|1359|1360)$/
      for(let item of list) {
        
        if(item.paidCuringService&&item.paidCuringService.length>0) {
          for(let item2 of item.paidCuringService) {
            if(idReg.test(item2.curingServiceId)) {
              this.mustAgree = true
              return
            }
          }
        }

        if(item.unpaidCuringService&&item.unpaidCuringService.length>0) {
          for(let item2 of item.unpaidCuringService) {
            if(idReg.test(item2.curingServiceId)) {
              this.mustAgree = true
              return
            }
          }
        }

      }
    },

    onlineDetail() {
      let couponCode = "";
      if (JSON.stringify(this.coupon) == "{}") {
        if (!this.sizeNum) {
          couponCode = null;
        } else {
          couponCode = "notUse";
        }
      } else {
        couponCode = this.coupon.couponCode;
      }
      this.sizeNum++;

      if (this.isActive) {
        params.couponCode = "notUse";
      }
      let params = {
        virtualGoodsIds: this.onlineIdStr,
        useSurplus: this.useBalance ? 1 : 0,
        useExternalSurplus: 1,
        couponCode
      };
      myApi
          .onlineDetail(params)
          .then(res => {
            this.detail = res;
            if (this.detail.promotionGifts) {
              if (this.detail.promotionGifts[0]) {
                this.gitfId = this.detail.promotionGifts[0].gifts[0].id;
                this.promotionId = this.detail.promotionGifts[0].promotionId;
              }
            }
            if (!this.detail.surplusAmount && this.useBalance) {
              this.useBalance = false;
            }
            if (res.matchCustomerCoupon) {
              this.couponList = res.matchCustomerCoupon;
            } else {
              this.couponList = [];
            }
            if (res.useCoupon) {
              this.coupon = res.useCoupon;
            }
            // this.takeOne();
          })
          .catch(res => {
            // alert(res.code);
            if (res.code == 10010) {
              orderApi.unpaid().then(res => {
                if (!res) {
                } else {
                  orderApi.settlementConcel(res.settlementCode).then(() => {
                    this.settlement();
                  });
                }
              });
            }
          });
    },

    choseCouponList(item) {
      this.coupon = item;
      this.isShow = false;
      //重新申请结算单信息
      this.settlement();
    },
    selectCoupon() {
      if (this.couponList.length == 0) {
        Toast("无可用优惠券");
        return;
      }
      this.isShow = true;
    },
    changeSwitch() {
      this.useBalance = !this.useBalance;
      this.settlement();
    },
    getItem(item) {
      let backgroundImg = "",
        title = "";

      switch (0) {
        // 0:满减 1:打折 2:礼物
        case 0:
          backgroundImg = "coupon_mask1";
          title = '88<span class="aa">元</span>';
          break;
        case 1:
          backgroundImg = "coupon_mask2";
          title = '8.8<span class="aa">折</span>';
          break;
        case 2:
          backgroundImg = "coupon_mask3";
          title = "赠品";
          break;
      }
      // 0:不能使用 1:可以使用

      // backgroundImg += '.1'

      return { backgroundImg: backgroundImg, title: item.couponName };
    },
    action() {
      this.confirm();
    },
    readActh(){
        const code = this.$route.query.code || publicObj.GetQueryString('code') || '';
        if (code) {
          //  alert('有code');
          // alert('这是CODE'+code);
          loginApi.getAUthUrl({
            wxAuthorizeCode: code
          }).then(res => {
            localStorage.setItem(publicObj.openId,res.openId);
            localStorage.setItem(publicObj.unionId,res.unionId);
            this.confirm()
          })
        }
    },
    toAuthorize(){
        Dialog.alert({
            message: '未授权，请先完成授权',
        }).then(() => {
            let params = {
                redirectUri :  window.location.href
            }

            loginApi.authorizeUrl(params).then((res)=>{
                location.replace(res);
            })
        });
    },
    confirm() {
      let _this = this;
      if (!this.agreement) {
        Toast("请您仔细阅读并同意包拯协议");
        return;
      }

      if(this.orderType==='online') {
        this.onlinePay()
        return
      }

      let couponCode = "";
      if (JSON.stringify(this.coupon) == "{}") {
        couponCode = "notUse";
      } else {
        couponCode = this.coupon.couponCode;
      }
      const openId = localStorage.getItem(publicObj.openId);
      let payParams = payObj.getPayParams(this.payType);
      //额外获取OPID
      
      //支付参数
      let params = {
        orderCode: this.settlementId,
        paymentPlatform: payParams.payChannel,
        couponCode: couponCode,
        useSurplus: this.useBalance ? 1 : 0,
        openId: openId,
        entrance: this.detail.entrance,
        paymentType: this.payTypeOther == "1" ? 20 : 10,
        useExternalSurplus: 1
      };

      if(this.chooseMemberCard) {
        params.rechargeRuleId = this.payItem.id
      }

      if (this.isActive) {
        params.couponCode = "notUse";
      }

      if (this.gitfId) {
        params.gifts = {
          promotionId: this.promotionId,
          giftsIds: [this.gitfId]
        };
      }

      if (this.isWeiXin && !openId) {
        Dialog.confirm({
          title: "报告！加载异常",
          message: "或许我们应该忽略这场尴尬，重新登录！"
        })
          .then(() => {
            sessionStorage.setItem("url", location.href);
            this.$store.commit("token", "");
            localStorage.clear();
            location.replace(location.origin + "/login");
          })
          .catch(() => {
            // on cancel
          });
        return;
      }
      this.paying = true;
      this.payingText = "支付中...";
      if (this.scheme) {
        params.backUrl = payParams.backUrl + "?type=3";
        myApi
          .createOrderOther(params)
          .then(res => {
            let cuxiaoName = "无促销";
            if (this.detail.settlementDiscount) {
              this.detail.settlementDiscount.forEach(element => {
                if (element.type == "promotion") {
                  cuxiaoName = element.discountList.name;
                }
              });
            }

            zhugeObj.track({
              title: "方案中-去结算-支付",
              content: {
                订单信息: this.settlementId,

                优惠券: this.detail.useCoupon
                  ? this.detail.useCoupon.couponName
                  : "未使用",
                订单金额: this.detail.amount,
                支付方式: params.paymentPlatform,
                促销抵扣: cuxiaoName,
                实付金额: this.detail.realAmount,
                支付: "成功",
                页面是否展示年卡: this.promotionRechargeRule&&this.promotionRechargeRule.type==20?'是':'否',
                是否使用年卡: this.chooseMemberCard?'是':'否'
              }
            });

            if (res.realAmount == 0) {
              this.$router.push({ name: "evaluate", query: { type: 3 } });
              return;
            }

            if (params.paymentPlatform == "WeChat_h5") {
              window.location.href = res.paymentData.h5PayUrl;

              return;
            }

            if (params.paymentPlatform == "AliPay_h5") {
              window.location.href = res.paymentData.h5PayUrl;
              return;
            }

            payObj.confirmPay(
              payParams.payChannel,
              res.paymentData,
              3,
              function() {
                _this.paying = false;
                _this.payingText = "支付";
              }
            );
          })
          .catch(res => {
            if (res.code == 10010) {
              // Dialog.alert({
              //   message: '您还有尚未结算的结算单，请去支付'
              // }).then(() => {
              //   this.$router.push({name:'orderList',params:{type:1}})
              //   // on close
              // });
              orderApi.unpaid().then(res => {
                if (!res) {
                } else {
                  orderApi.settlementConcel(res.settlementCode).then(() => {});
                }
              });
            }
            let cuxiaoName = "无促销";
            if (this.detail.settlementDiscount) {
              this.detail.settlementDiscount.forEach(element => {
                if (element.type == "promotion") {
                  cuxiaoName = element.discountList.name;
                }
              });
            }
            zhugeObj.track({
              title: "方案中-去结算-支付",
              content: {
                订单信息: this.settlementId,
                优惠券: this.detail.useCoupon
                  ? this.detail.useCoupon.couponName
                  : "未使用",
                订单金额: this.detail.amount,

                支付方式: params.paymentPlatform,
                促销抵扣: cuxiaoName,
                实付金额: this.detail.realAmount,
                支付: "不成功"
              }
            });
            this.paying = false;
            this.payingText = "支付";
          });
        return;
      }

      //预约单支付新增参数集合
      params.pickingWay = this.sendFrom.sendType;
      console.log(this.sendFrom);
      if (params.pickingWay == 40) {
        params.pickingDate = this.sendFrom.pickingDate;
        params.pickingTime = this.sendFrom.pickingTime;
        params.customerAddressId = this.sendFrom.customerAddressId;

        //参数验证
        if (!params.customerAddressId) {
          Toast("请选择地址");
          _this.paying = false;
          _this.payingText = "支付";

          return;
        }

        if (!params.pickingDate) {
          Toast("请选择上门时间");
          _this.paying = false;
          _this.payingText = "支付";
          _this.$refs.setAdr.timeShowAction(1);
          return;
        }
      }

      params.backUrl = payParams.backUrl + "?type=1";

      if (this.isTeam) {
        params.backUrl =
          window.location.protocol +
          "//" +
          window.location.host +
          "/teamDetail?from=1&orderCode=" +
          params.orderCode;
        params.paymentType = 20;
      }

      myApi
        .createOrder(params)
        .then(res => {
          let cuxiaoName = "无促销";
          if (this.detail.settlementDiscount) {
            this.detail.settlementDiscount.forEach(element => {
              if (element.type == "promotion") {
                cuxiaoName = element.discountList.name;
              }
            });
          }

          //微信外h5支付
          if (res.realAmount == 0 && !this.isTeam) {
            this.$router.push({ name: "evaluate", query: { type: 1 } });
            return;
          } else if (res.realAmount == 0 && this.isTeam) {
            window.location.href = params.backUrl;

            return;
          }

          if (params.paymentPlatform == "WeChat_h5") {
            window.location.href = res.paymentData.h5PayUrl;
            return;
          }

          if (params.paymentPlatform == "AliPay_h5") {
            window.location.href = res.paymentData.h5PayUrl;
            return;
          }

          payObj.confirmPay(
            payParams.payChannel,
            res.paymentData,
            1,
            params.backUrl,
            function() {
              _this.paying = false;
              _this.payingText = "支付";
            }
          );
          zhugeObj.track({
            title: "用户支付",
            content: {
              订单信息: this.settlementId,
              支付类型: this.payTypeOther == "1" ? "立即支付" : "诊断后付款",
              邮寄方式: params.pickingWay == 40 ? "顺丰上门" : "自己快递",
              优惠券: this.detail.useCoupon
                ? this.detail.useCoupon.couponName
                : "未使用",
              订单金额: this.detail.amount,
              支付方式: params.paymentPlatform,
              促销抵扣: cuxiaoName,
              实付金额: this.detail.realAmount,
              支付: "成功",
              页面是否展示年卡: this.promotionRechargeRule&&this.promotionRechargeRule.type==20?'是':'否',
              是否使用年卡: this.chooseMemberCard?'是':'否'
            }
          });
          
        })
        .catch(res => {
          if (res.code == 10088) {
            Toast(res.message);
            return;
          }
          if (res.code == 10086) {
            Toast(res.message);
            return;
          }
          if (res.code == 10010) {
            Dialog.alert({
              message: "取消待支付订单后才可一起结算哦"
            }).then(() => {
              this.$router.push({ name: "orderList", params: { type: 1 } });
              // on close
            });
          }
          let cuxiaoName = "无促销";
          if (this.detail.settlementDiscount) {
            this.detail.settlementDiscount.forEach(element => {
              if (element.type == "promotion") {
                cuxiaoName = element.discountList.name;
              }
            });
          }
          zhugeObj.track({
            title: "用户支付",
            content: {
              订单信息: this.settlementId,
              支付类型: this.payTypeOther == "1" ? "立即支付" : "诊断后付款",
              邮寄方式: params.pickingWay == 40 ? "顺丰上门" : "自己快递",
              优惠券: this.detail.useCoupon
                ? this.detail.useCoupon.couponName
                : "未使用",
              订单金额: this.detail.amount,
              支付方式: params.paymentPlatform,
              促销抵扣: cuxiaoName,
              实付金额: this.detail.realAmount,
              支付: "不成功"
            }
          });
          this.paying = false;
          this.payingText = "支付";
        });
    },

    onlinePay() {
      let couponCode = "";
      if (JSON.stringify(this.coupon) == "{}") {
        couponCode = "notUse";
      } else {
        couponCode = this.coupon.couponCode;
      }
      const openId = localStorage.getItem(publicObj.openId);
      let payParams = payObj.getPayParams(this.payType);
      //额外获取OPID
      
      //支付参数
      let params = {
        couponCode,
        entrance: 'VIRTUAL_GOODS', // this.detail.entrance
        openId,
        paymentPlatform: payParams.payChannel,
        paymentType: this.payTypeOther == "1" ? 20 : 10,
        useSurplus: this.useBalance ? 1 : 0,
        virtualGoodsIds: this.onlineIdStr.split(','),
        useExternalSurplus: 1
      };

      if (this.isActive) {
        params.couponCode = "notUse";
      }

      if (this.isWeiXin && !openId) {
        Dialog.confirm({
          title: "报告！加载异常",
          message: "或许我们应该忽略这场尴尬，重新登录！"
        })
          .then(() => {
            sessionStorage.setItem("url", location.href);
            this.$store.commit("token", "");
            localStorage.clear();
            location.replace(location.origin + "/login");
          })
          .catch(() => {
            // on cancel
          });
        return;
      }
      this.paying = true;
      this.payingText = "支付中...";
      params.backUrl = payParams.backUrl + "?type=100";
        myApi
          .createOnlineOther(params)
          .then(res => {
            let cuxiaoName = "无促销";
            if (this.detail.settlementDiscount) {
              this.detail.settlementDiscount.forEach(element => {
                if (element.type == "promotion") {
                  cuxiaoName = element.discountList.name;
                }
              });
            }

            zhugeObj.track({
              title: "方案中-去结算-支付",
              content: {
                订单信息: this.settlementId,

                优惠券: this.detail.useCoupon
                  ? this.detail.useCoupon.couponName
                  : "未使用",
                订单金额: this.detail.amount,
                支付方式: params.paymentPlatform,
                促销抵扣: cuxiaoName,
                实付金额: this.detail.realAmount,
                支付: "成功",
                页面是否展示年卡: this.promotionRechargeRule&&this.promotionRechargeRule.type==20?'是':'否',
                是否使用年卡: this.chooseMemberCard?'是':'否'
              }
            });

            if (res.realAmount == 0) {
              window.location.href = location.origin + '/order/paySuccess?type=100'
              return;
            }

            if (params.paymentPlatform == "WeChat_h5") {
              window.location.href = res.paymentData.h5PayUrl;

              return;
            }

            if (params.paymentPlatform == "AliPay_h5") {
              window.location.href = res.paymentData.h5PayUrl;
              return;
            }
            payObj.confirmPay(
              payParams.payChannel,
              res.paymentData,
              3,
              location.origin + '/order/paySuccess?type=100',
              function() {
                _this.paying = false;
                _this.payingText = "支付";
              }
            );
          })
          .catch(res => {
            if (res.code == 10010) {
              orderApi.unpaid().then(res => {
                if (!res) {
                } else {
                  orderApi.settlementConcel(res.settlementCode).then(() => {});
                }
              });
            }
            let cuxiaoName = "无促销";
            if (this.detail.settlementDiscount) {
              this.detail.settlementDiscount.forEach(element => {
                if (element.type == "promotion") {
                  cuxiaoName = element.discountList.name;
                }
              });
            }
            zhugeObj.track({
              title: "方案中-去结算-支付",
              content: {
                订单信息: this.settlementId,
                优惠券: this.detail.useCoupon
                  ? this.detail.useCoupon.couponName
                  : "未使用",
                订单金额: this.detail.amount,

                支付方式: params.paymentPlatform,
                促销抵扣: cuxiaoName,
                实付金额: this.detail.realAmount,
                支付: "不成功"
              }
            });
            this.paying = false;
            this.payingText = "支付";
          });
    }

  }
};
</script>

<style scoped lang="scss">
.cool-dfs{
  width: 100%;
  z-index: 999;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.79);
  top: 0;
}
.cool-dfsd{
  width: 100%;
  z-index: 999;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.79);
  height:800px;
  top: 0;
  left:10000px;
}
.active_other {
  border: 1px solid rgba(122, 223, 223, 1) !important;
  background: rgba(243, 251, 251, 1) !important;
  p {
    color: #7adfdf !important;
  }
}
.type {
  display: flex;
  justify-content: space-between;
  width: 100%;
  div {
    width: 48%;
    border-radius: 10px;
    height: 94px;
    border: 1px solid #c9c8c8;
    position: relative;
    text-align: center;
    // display: flex;
    // justify-content:center;
    align-items: center;
    // vertical-align: center;
    // padding-top: 40px;
    p {
      font-size: 26px;
      font-weight: 500;
      line-height: 57px;
      color: #c9c8c8;
    }
    .dero {
      font-size: 22px;
      margin-top: -15px;
      font-weight: normal !important;
    }
    img {
      width: 50px;
      height: 50px;
      // margin-top: 20px;
      margin-right: 22px;
    }
    span {
      line-height: 50px;
      font-size: 28px;
      color: #c9c8c8;
    }
  }
}
.payTypeOther_chose {
  display: flex;
  justify-content: space-between;
  img {
    width: 336px;
    height: 96px;
  }
}
.defult_img {
  width: 64px;
  position: relative;
  // top:4px;
  margin-left: 20px;
  height: 28px;
}
.payTypeOtherDialog {
  min-height: 400px;
  .title {
    border-bottom: 1px solid rgba(155, 155, 155, 0.3);
    padding-bottom: 20px;
  }
}
.chose_content {
  padding: 0 30px;
  margin-bottom: 40px;
  .text {
    padding-left: 60px;
    font-weight: 400;
    font-size: 26px;
    color: #333333;
    margin-top: 16px;
    opacity: 0.5;
  }
}
.radio_content {
  display: flex;
  justify-content: flex-start;
  span {
    margin-left: 30px;
    font-size: 28px;
    font-weight: 500;
    line-height: 30px;
  }
}
.mt104 {
  margin-top: 84px;
}
.radio_pop {
  width: 60%;
  height: 180px;
}
.mycell {
  height: 90px;
  line-height: 90px;
  padding-left: 20px;
  padding-right: 20px;
}
.bgg {
  background: #f6f6f6;
  display: flex;
  justify-content: space-between;
  padding: 30px 40px;
}
.address {
  margin-top: 84px;
}
.payTypeOther {
  display: flex;
  line-height: 40px;
  img {
    width: 14px;
    height: 24px;
    margin-left: 20px;
    position: relative;
    top: 10px;
  }
}
.gift_num {
  line-height: 60px;
  // margin-top: 22px;
  text-decoration: line-through;
}
.gift_title {
  font-size: 30px;
  font-weight: 500;
}
.gift_content {
  margin-top: 20px;
}
.gift_list {
  display: flex;
  justify-content: flex-start;
  font-size: 26px;
  line-height: 30px;
  line-height: 60px;
  align-items: center;
  & > span {
    margin-left: 16px;
  }
  img {
    height: 60px;
    width: 60px;
    margin-left: 16px;
    border-radius: 3px;
    box-shadow: 0px 1px 13px 0px rgba(0, 0, 0, 0.15);
  }
}
.borderNone {
  border: none !important;
}
.reds {
  color: #f56d6d;
}
.prefere {
  display: inline-block;
  background: #173657;
  font-size: 18px;
  border-radius: 4px;
  color: #fff;
  margin-left: 8px;
  position: relative;
  top: -4.6px;
  padding: 5px 20px;
}
.paddigleft {
  padding-left: 70px !important;
}
.couponRadio {
  position: absolute;
  top: 41%;
  left: 40px;
}
.alipay {
  width: 52px !important;
  height: 52px !important;
}
.paddingp {
  padding-bottom: 100px !important;
}
.moreGoods {
  display: flex;
  align-items: center;
}
.moreTips {
  width: 40px;
  margin-left: 16px;
}
.item_content {
  max-height: 950px;
  overflow-y: scroll;
}
.goodsList {
  padding-top: 20px;
  display: flex;
  justify-content: center;
  // padding-bottom: 40px;
  // box-shadow:0px 8px 60px 0px rgba(0,0,0,0.1);
  // border-radius:0px 0px 20px 20px;
  flex-wrap: wrap;
  margin-bottom: 40px;
  & > div {
    width: 670px;
  }
  .title {
    font-size: 30px;
    font-weight: 500;
    line-height: 60px;
  }
  .img_cont {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
  }
  .item_icon {
    width: 120px;
    height: 120px;
    border-radius: 8px;
    margin-right: 10px;
  }
}
.postage {
  position: fixed;

  color: #c4ab6a;
  width: 100%;
  bottom: 110px;
  line-height: 48px;
  font-size: 24px;
  border-radius: 12px 12px 0px 0px;
  text-indent: 70px;
  background: url("/images/order/smile.png") 20px center no-repeat;
  background-size: 30px;
  background-color: #ffe7a7;
}
.describe {
  margin-top: 10px;
}
.time {
  display: inline-block;
  margin-top: 15px;
}
.conpentitle {
  font-size: 60px;
}
.my_button {
  width: 350px;
  height: 84px;
  line-height: 84px;
  min-width: 224px;
  text-align: center;
  font-size: 32px;
  background: $primary-color;
  color: $white-color;
  border-radius: 44px;
  margin-top: 30px;
  float: right;
  margin-right: 30px;
  margin-bottom: 30px;
}
.border-bottom {
  border-bottom: 1px solid #cecece;
}
.title_text {
  font-size: 30px;
  font-weight: 500;
  line-height: 50px;
  margin-bottom: 24px;
}
.pay {
  padding-bottom: 150px;
}
.toolbar {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  justify-content: space-between;
  padding-top: 0;
  div {
    font-size: 26px;
    color: rgba(242, 73, 73, 0.8);
    span {
      font-size: 40px;
    }
  }
}
.money {
  font-weight: 500;
  margin-left: 10px;
}
.copyright_content {
  // display: flex;
  // justify-content: left;
}
.copyright {
  // display: flex;
  // justify-content: flex-start;
  margin-left: 40px;
  width: 670px;
  color: #999999;
  font-size: 25px;
  margin-top: 44px;
  line-height: 35px;
  span {
    color: $theme-color;
    text-decoration: underline;
    text-underline: $theme-color;
  }
}
.fwnolmol {
  font-size: 28px;
  font-weight: normal;
  line-height: 30px;
}
.container {
  // padding-top: 134px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 20px;
  .amount,
  .coupon {
    width: 670px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 26px;

    span {
      line-height: 42px;
      &.right {
        padding-right: 30px;
        background: url("/images/public/arrow-right.png") no-repeat right center;
        background-size: 14px 22px;
      }
    }
  }
  .amount {
    margin-bottom: 40px;
  }
  .pay-info {
    padding: 40px 0;
    width: 670px;
    li {
      display: flex;
      justify-content: space-between;
      margin-bottom: 26px;
      font-size: 26px;
      color: #333;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .pay-style {
    padding: 40px 0;
    padding-bottom: 0;
    width: 670px;
    li {
      display: flex;
      align-items: center;
      margin-bottom: 40px;
      .icon {
        width: 52px;
        height: 48px;
        object-fit: cover;
        margin-right: 44px;
        flex: none;
      }
      .name {
        width: 480px;

        border-bottom: 2px solid #eee;
        flex: none;
        font-size: 28px;
        color: #333333;
        line-height: 52px;
      }
      .radio {
        margin-left: 40px;
        flex: none;
      }
    }
  }
  .copyright {
    display: flex;
    align-items: center;
    padding-top: 46px;
    div {
      margin-right: 20px;
    }
    span {
      color: $theme-color;
      text-decoration: underline;
      text-underline: $theme-color;
    }
  }
}

.goodsnum {
  margin-left: 16px;
  color: #999999;
  font-size: 24px;
}
.van-popup--bottom {
  width: 101%;
}
.containers {
  // height: 1000px;
  padding-top: 30px;
  padding-bottom: 30px;
  position: relative;
  max-height: 1000px;
  .title {
    line-height: 40px;
    margin-bottom: 30px;
    margin-left: 30px;
    margin-right: 30px;
    font-weight: 500;
  }
  ul {
    // position: absolute;
    // top: 100px;
    left: 0;
    bottom: 0;
    // overflow-y: scroll;
    width: 100%;
    max-height: 800px;
    overflow-y: scroll;
    padding-bottom: 10px;
    padding-top: 10px;
    li {
      height: 200px;
      padding: 20px;
      padding-left: 20px;
      padding-right: 20px;
      // margin-bottom: -20px;
      /*border-radius:100px;*/
      background: no-repeat left top;
      background-size: 100%;
      position: relative;
      .inner {
        width: 420px;
        padding: 6px 40px 0;
      }
      h3 {
        font-size: 60px;
        font-weight: bold;
        line-height: 84px;
      }
      h4 {
        line-height: 34px;
      }
      h5,
      time {
        line-height: 28px;
      }
    }
  }
  .bottom {
    position: absolute;
    width: 690px;
    bottom: 30px;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    .submit {
      margin-left: 20px;
    }
  }
  .close {
    width: 36px;
    height: 36px;
    position: absolute;
    top: 30px;
    right: 30px;
    background: url("/images/public/close.png") no-repeat center;
    background-size: 32px;
  }
}
.code-title {
  width: 176px;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 50px;
}
.code-dis {
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(63, 63, 63, 0.85);
  text-align: center;
  color: #3f3f3f;
  padding-top: 30px;
  span {
    color: #6ddede;
  }
}
.code-button {
  width: 100%;
  height: 72px;
  margin-top: 50px;
  text-align: center;
  span {
    font-size: 32px;
    padding: 20px 150px;
    border-radius: 42px;
    border: 1px solid #141817;
  }
}
.title-dig{
  width:100%;
  text-align: center;
  height: 70px;
  font-size: 48px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #6DDEDE;
  background-color:#ffffff ;
  line-height: 33px;
}
.title-dig-cion{
  width:100%;
  height:50px;
  text-align: right;
  padding: 20px 0px 0 0;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #BABBBC;
  background-color:#ffffff ;
  line-height: 50px;
}
.serviceBox{
  width: 100%;
  height: calc(100% - 170px);
  font-size: 40px;
  overflow-y: auto;
  .serviceContent{
    width: 100%;
    padding: 40px;
    box-sizing: border-box;
    transition: .5s;
    .serviceH6{
      line-height: 46px;
    }
  }
  .serviceContent2{
    margin-top: -200px;
  }
}
.serviceBtn{
  width: 70%;
  height: 40px;
  font-size: 36px;
  text-align: center;
  font-weight: 600;
  border-radius: 40px;
  line-height: 40px;
  color: white;
  background-color: #7ADFDF;
  margin: 30px auto 0;
  padding: 20px 50px;
}
.serviceBtnGray{
  background: gray;
}

.cardBox {
		width: 100%;
		box-sizing: border-box;
		padding: 48px 30px;
		// margin-top: -100px;
		border-radius: 32px 32px 0 0;
		background-color: white;
		.cardBoxSon1 {
			margin-bottom: 30px;
			.cardType {
				font-size: 32px;
				line-height: 40px;
				font-weight: 500;
				margin-bottom: 18px;
			}
			.vipCard {
				width: 690px;
				height: 196px;
				box-sizing: border-box;
				display: flex;
				justify-content: space-between;
				flex-wrap: nowrap;
				margin-bottom: 24px;
				.title {
					height: 50px;
					padding: 0 20px;
					line-height: 50px;
					font-size: 24px;
					color: white;
					background: url("/images/my/vipCard_title.png") no-repeat;
					background-size: cover;
				}
				.price {
					margin-top: 30px;
					font-size: 48px;
					margin-left: 20px;
				}
				.word {
					font-size: 24px;
					margin-top: 20px;
					margin-left: 20px;
					color: #aaaaaa;
				}
				.recharge {
					margin-right: 20px;
					width: 194px;
					height: 66px;
					font-size: 32px;
					color: white;
					line-height: 66px;
					text-align: center;
					border-radius: 33px;
					background-color: #333333;
					margin-top: 66px;
				}
			}

				.vipCard_1 {
					background: url("/images/my/vipCard1.png") no-repeat;
					background-size: cover;
				}
				.vipCard_2 {
					background: url("/images/my/vipCard2.png") no-repeat;
					background-size: cover;
				}
				.vipCard_3 {
					background: url("/images/my/vipCard3.png") no-repeat;
					background-size: cover;
				}
				.vipCard_4 {
					background: url("/images/my/vipCard4.png") no-repeat;
					background-size: cover;
				}
		}
		.cardBoxSon2 {
			margin-bottom: 30px;
			.cardType {
				font-size: 32px;
				line-height: 40px;
				font-weight: 500;
				margin-bottom: 18px;
			}
			.discountCard {
				width: 690px;
				height: 260px;
				box-sizing: border-box;
				display: flex;
				justify-content: space-between;
				flex-wrap: nowrap;
				margin-bottom: 24px;
				padding: 30px 20px 0 50px;
				box-sizing: border-box;
				.title {
					line-height: 46px;
					font-size: 26px;
					color: #FFF;
          font-weight: bold;
				}
        .savePrice{
          color: rgb(252,175,72);
        }
				.word {
					margin-top: 4px;
					font-size: 36px;
					color: #FFF;
          font-weight: bold;
				}
				.day {
					margin-top: 12px;
					font-size: 22px;
					color: white;
				}
        .priceCard{
          width: 290px;
          padding-top: 152px;
          font-size: 30px;
          text-align: right;
        }
				.radio {
					line-height: 66px;
					margin-top: 146px;
          .noRadio{
            width: 40px;
            height: 40px;
            box-sizing: border-box;
            border: 2px solid #141817;
            border-radius: 50%;
            background: white;
          }
          .yesRadio{
            width: 40px;
            height: 40px;
            background: url('/images/public/checked.png') no-repeat;
            background-size: cover;
          }
				}
			}

				.discountCard_1 {
          border-radius: 20px;
					background: url("/images/my/discountCard_year.jpg") no-repeat;
					background-size: cover;
				}
		}
	}

  .popupInners {
    background: #fff;
    border-radius: 32px 32px 0 0;
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 30px;
    padding-bottom: env(safe-area-inset-bottom);
    .close_cont {
      width: 100%;
      height: 80px;
      box-sizing: border-box;
      padding-top: 40px;
      .close {
        width: 182px;
        height: 20px;
        border-radius: 10px;
        background: #f0f0f0;
        margin: 0 auto;
      }
    }

    .msgBox {
      width: 100%;
      box-sizing: border-box;
      padding: 0px 60px 0;
      .price {
        display: flex;
        padding-bottom: 36px;
        padding: 48px 0px 36px;
        justify-content: space-between;
        .price32 {
          font-size: 32px;
        }
        .price48 {
          font-size: 48px;
        }
      }
      .priceLine {
        height: 1px;
        background: #979797;
      }
    }
    .wordBox {
      width: 100%;
      box-sizing: border-box;
      padding: 0px 30px 30px;
      .word {
        width: 100%;
        box-sizing: border-box;
        padding: 30px;
        border-radius: 12px;
        background-color: #f6f6f6;
        font-size: 24px;
        color: #686868;
        line-height: 40px;
      }
    }

    .pay-style {
      width: 100%;
      padding: 40px 30px 0;
      box-sizing: border-box;
      li {
        display: flex;
        align-items: center;
        margin-bottom: 40px;
        position: relative;
        .icon {
          width: 52px;
          height: 48px;
          object-fit: cover;
          margin-right: 16px;
          flex: none;
        }
        .name {
          flex: none;
          font-size: 28px;
          color: #333333;
          line-height: 52px;
        }
        .radio {
          position: absolute;
          top: 5px;
          right: 0;
          flex: none;
        }
      }
    }
  }
.payBox {
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
  .myPay{
    width: 100%;
  }
}
</style>
